import defaultTheme from '../default';
import colors from '../colors';

export default {
  ...defaultTheme(colors.timeone),
  name: 'TimeOne',
};
